import Layout from '@layout/Index'

export const point = [
  {
    path: '/point',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'deduct/form/:userid',
        component: () => import(/* webpackChunkName: "point-deduct" */ './pages/PointDeductForm.vue'),
        name: '零豆扣除',
        meta: {
          title: '零豆扣除',
        },
      },
      {
        path: 'add/form/:userid',
        component: () => import(/* webpackChunkName: "point-add" */ './pages/PointAddForm.vue'),
        name: '零豆添加',
        meta: {
          title: '零豆添加',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/point/point.route.js